import { forwardRef, type TextareaHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './TextInput.module.css';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  rows?: number;
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ invalid, className, rows = 4, ...rest }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={clsx(styles.input, styles.textarea, invalid && styles.invalid, className)}
      {...rest}
    />
  ),
);
TextArea.displayName = 'TextArea';